export const PATIENT_EXTERNAL_DOCUMENTS_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}
